import React from 'react';
import { cn } from '@rocco/utils/cn';
import type { ProductPriceTileViewModel } from '@rocco/ui/tile-product/view-models/product';
import { formatPriceForProductTilePrice } from '@rocco/utils/format-price';

interface ProductTilePriceProps {
    price: ProductPriceTileViewModel | null;
}

export const ProductTilePrice = ({ price }: ProductTilePriceProps) => {
    // if price == null - we have `Price on Request` situation for this item - show nothing
    if (!price) {
        return null;
    }

    // we have some pricing - let's show it :)
    const hasDiscount =
        price.discountedAmount > 0 && price.discountedAmount < price.amount;

    return (
        <div className="flex gap-2 text-sm font-medium leading-none md:text-base">
            {price.prefix && <span>{price.prefix}</span>}

            {hasDiscount && (
                <span className="text-gray-500 line-through">
                    {formatPriceForProductTilePrice(
                        price.amount,
                        price.currency,
                        true
                    )}
                </span>
            )}

            <span className={cn(hasDiscount && 'text-brick-50')}>
                {formatPriceForProductTilePrice(
                    hasDiscount ? price.discountedAmount : price.amount,
                    price.currency,
                    true
                )}
            </span>
        </div>
    );
};
